import React, { useEffect } from 'react';

const ScrollToTop: React.FC = () => {
  useEffect(() => {
    // Disable browser's scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Scroll to top immediately
    window.scrollTo(0, 0);

    // Also handle page reload
    const handleLoad = () => {
      window.scrollTo(0, 0);
    };

    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };

    // Add event listeners
    window.addEventListener('load', handleLoad);
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup
    return () => {
      window.removeEventListener('load', handleLoad);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
